import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tradelogs: localStorage.getItem('tradelogs')
    ? JSON.parse(localStorage.getItem('tradelogs'))
    : null,
};

const tradelogsSlice = createSlice({
  name: 'tradelogs',
  initialState,
  reducers: {
    setTradelogs: (state, action) => {
      state.tradelogs = action.payload;
      localStorage.setItem('tradelogs', JSON.stringify(action.payload));
    },
  },
});

export const {setTradelogs } = tradelogsSlice.actions;

export default tradelogsSlice.reducer;
